// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_kD1","cls2":"DownloadOptionCard-cls2_8q- DownloadOptionCard-cls1_kD1"};